module.exports = __webpack_public_path__ + "static/media/2.44a5ee42.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/九宫格选中态/2.png
// module id = 1071
// module chunks = 0